var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"apply-container"},[_c('div',{staticClass:"main apply-content"},[_c('div',{staticClass:"trial",attrs:{"to":"","tag":"div"},on:{"click":function($event){return _vm.$store.commit('SET_DIALOGSHOWIF', true)}}},[_vm._v("\n        免费试用\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }